export { default } from "./useHandlePollAfterAssignmentUpdate";
